module.exports = {
  clientId: '696926193699-oek9v0vims65nmgngtim79pal6v3ronv.apps.googleusercontent.com',
  scopes: [
    'email',
    'https://www.googleapis.com/auth/adwords',
    'https://www.googleapis.com/auth/ddmconversions',
    'https://www.googleapis.com/auth/dfareporting',
    'https://www.googleapis.com/auth/dfatrafficking'
  ],
  discoveryDocs: [
    'https://www.googleapis.com/discovery/v1/apis/dfareporting/v3.3/rest'
  ]
}
